// extracted by mini-css-extract-plugin
export default {"container":"RatingBadge_container__X7N4b","star":"RatingBadge_star__Vb9Qf","starIcon":"RatingBadge_starIcon__q3zor"};